type DateRangeQuery = {
  startDate: string
  endDate: string
}

const isDateOnlyValue = (value: string) => /^\d{4}-\d{2}-\d{2}$/.test(value)

const toISOStringBoundary = (value: string, boundary: 'start' | 'end') => {
  if (!isDateOnlyValue(value)) {
    return value
  }

  const time = boundary === 'start' ? 'T00:00:00.000Z' : 'T23:59:59.999Z'
  return `${value}${time}`
}

export const normalizeStatsDateRangeQuery = <T extends DateRangeQuery>(
  params: T,
): T => ({
  ...params,
  startDate: toISOStringBoundary(params.startDate, 'start'),
  endDate: toISOStringBoundary(params.endDate, 'end'),
})
